// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1XFhS","productName":"Table_productName__acNM7"};